<template>
    <div class="customers-invites-copy-link">
        <button
            v-t="'crm.customers.invites.inviteLink.trigger'"
            type="button"
            class="button"
            @click="copy"
        />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { copyToClipboard } from '@speechki-frontend/shared/helpers/functions';

export default {
    name: 'CustomersInvitesCopyLink',
    props: {
        link: {
            type: String,
            required: true,
        },
    },
    methods: {
        ...mapActions(['pushToast']),
        copy() {
            copyToClipboard(this.link);
            this.pushToast({
                type: 'success',
                title: this.$t('crm.customers.invites.inviteLink.success'),
            });
        },
    },
};
</script>
